import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "UIInput" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "UIInput-Label" }, "MAX重量 ", -1)
const _hoisted_3 = ["disabled"]

import { withDefaults, computed } from "vue";
// const emit = defineEmits(["input"]);


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: null },
    isInterval: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
	(e: "update:modelValue", weight: number): number;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number | any, isInterval: boolean }





const weight = computed({
	get: () => props.modelValue,
	set: (value) => {
		// 値に変更があると呼ばれるsetter
		emit("update:modelValue", value);
	},
});

// type Props = {
// 	number: number;
// };

// defineProps<Props>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "number",
      inputmode: "numeric",
      min: "0",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(weight) ? (weight).value = $event : null)),
      onkeydown: "return event.keyCode !== 69",
      disabled: props.isInterval
    }, null, 8, _hoisted_3), [
      [_vModelText, _unref(weight)]
    ])
  ]))
}
}

})